import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-popup',
  templateUrl: './video-popup.component.html',
  styleUrls: ['./video-popup.component.css']
})
export class VideoPopupComponent {@Input() videoUrl: string = '';
  @Output() closed = new EventEmitter<void>();
  safeUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    // Remove initialization from constructor
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoUrl'] && changes['videoUrl'].currentValue) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
    }
  }

  close() {
    const overlay = document.querySelector('.popup-overlay') as HTMLElement;
    if (overlay) {
      overlay.style.animation = 'fadeOut 0.16s ease-out';
      setTimeout(() => this.closed.emit(), 160);
    } else {
      this.closed.emit();
    }
  }
}
